var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "channel-picker-inline" }, [
    _c(
      "div",
      { staticClass: "search-wrapper" },
      [
        _c("a-input-search", {
          attrs: { placeholder: _vm.$t("message.searchChannel") },
          model: {
            value: _vm.search,
            callback: function ($$v) {
              _vm.search = $$v
            },
            expression: "search",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "btnGroup" },
      [
        _c(
          "SupsisButton",
          {
            attrs: {
              classNames:
                _vm.mode === "active"
                  ? "btnGroupItem selected"
                  : "btnGroupItem ",
              primary: _vm.mode === "active",
              ghost: _vm.mode !== "active",
              small: "",
            },
            on: {
              click: function () {
                return _vm.changeMode("active")
              },
            },
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("message.activeChannels")) +
                "\n        "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "SupsisButton",
          {
            attrs: {
              classNames:
                _vm.mode === "deleted"
                  ? "btnGroupItem selected"
                  : "btnGroupItem ",
              primary: _vm.mode === "deleted",
              ghost: _vm.mode !== "deleted",
              small: "",
            },
            on: {
              click: function () {
                return _vm.changeMode("deleted")
              },
            },
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("message.deleteChannels")) +
                "\n        "
            ),
          ]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "groups" },
      [
        _vm.getFilteredChannels("whatsapp-business-api").length
          ? _c("div", { staticClass: "group-title" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("message.channelGroupWhatsappBusinessApi")) +
                  "\n        "
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._l(
          _vm.getFilteredChannels([
            "whatsapp-business-api",
            "whatsapp-business-api-supsis",
          ]),
          function (channel) {
            return _c(
              "div",
              {
                key: channel._id,
                staticClass: "list-item",
                class: { selected: _vm.isSelectedChannel(channel) },
                on: {
                  click: function (e) {
                    return _vm.change(e, channel._id)
                  },
                },
              },
              [
                _vm.multiple
                  ? _c("a-checkbox", {
                      staticClass: "segment-checkbox",
                      attrs: { checked: _vm.isSelectedChannel(channel) },
                      on: {
                        click: function (e) {
                          return _vm.change(e, channel._id)
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(channel.name))]),
              ],
              1
            )
          }
        ),
        _vm._v(" "),
        _vm.getFilteredChannels("whatsapp-v2").length
          ? _c("div", { staticClass: "group-title" }, [
              _vm._v(_vm._s(_vm.$t("message.channelGroupWhatsappV2"))),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.getFilteredChannels("whatsapp-v2"), function (channel) {
          return _c(
            "div",
            {
              key: channel._id,
              staticClass: "list-item",
              class: { selected: _vm.isSelectedChannel(channel) },
              on: {
                click: function (e) {
                  return _vm.change(e, channel._id)
                },
              },
            },
            [
              _vm.multiple
                ? _c("a-checkbox", {
                    staticClass: "segment-checkbox",
                    attrs: { checked: _vm.isSelectedChannel(channel) },
                    on: {
                      click: function (e) {
                        return _vm.change(e, channel._id)
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(channel.name))]),
            ],
            1
          )
        }),
        _vm._v(" "),
        _vm.getFilteredChannels("whatsapp-unipile").length
          ? _c("div", { staticClass: "group-title" }, [
              _vm._v(_vm._s(_vm.$t("message.channelGroupWhatsappV3"))),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.getFilteredChannels("whatsapp-unipile"), function (channel) {
          return _c(
            "div",
            {
              key: channel._id,
              staticClass: "list-item",
              class: { selected: _vm.isSelectedChannel(channel) },
              on: {
                click: function (e) {
                  return _vm.change(e, channel._id)
                },
              },
            },
            [
              _vm.multiple
                ? _c("a-checkbox", {
                    staticClass: "segment-checkbox",
                    attrs: { checked: _vm.isSelectedChannel(channel) },
                    on: {
                      click: function (e) {
                        return _vm.change(e, channel._id)
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(channel.name))]),
            ],
            1
          )
        }),
        _vm._v(" "),
        _vm.getFilteredChannels("instagram").length
          ? _c("div", { staticClass: "group-title" }, [
              _vm._v(_vm._s(_vm.$t("message.channelGroupInstagram"))),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.getFilteredChannels("instagram"), function (channel) {
          return _c(
            "div",
            {
              key: channel._id,
              staticClass: "list-item",
              class: { selected: _vm.isSelectedChannel(channel) },
              on: {
                click: function (e) {
                  return _vm.change(e, channel._id)
                },
              },
            },
            [
              _vm.multiple
                ? _c("a-checkbox", {
                    staticClass: "segment-checkbox",
                    attrs: { checked: _vm.isSelectedChannel(channel) },
                    on: {
                      click: function (e) {
                        return _vm.change(e, channel._id)
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(channel.name))]),
            ],
            1
          )
        }),
        _vm._v(" "),
        _vm.getFilteredChannels("messenger").length
          ? _c("div", { staticClass: "group-title" }, [
              _vm._v(_vm._s(_vm.$t("message.channelGroupMessenger"))),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.getFilteredChannels("messenger"), function (channel) {
          return _c(
            "div",
            {
              key: channel._id,
              staticClass: "list-item",
              class: { selected: _vm.isSelectedChannel(channel) },
              on: {
                click: function (e) {
                  return _vm.change(e, channel._id)
                },
              },
            },
            [
              _vm.multiple
                ? _c("a-checkbox", {
                    staticClass: "segment-checkbox",
                    attrs: { checked: _vm.isSelectedChannel(channel) },
                    on: {
                      click: function (e) {
                        return _vm.change(e, channel._id)
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(channel.name))]),
            ],
            1
          )
        }),
        _vm._v(" "),
        _vm.getFilteredChannels("telegram-unipile").length
          ? _c("div", { staticClass: "group-title" }, [
              _vm._v(_vm._s(_vm.$t("message.channelGroupTelegram"))),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.getFilteredChannels("telegram-unipile"), function (channel) {
          return _c(
            "div",
            {
              key: channel._id,
              staticClass: "list-item",
              class: { selected: _vm.isSelectedChannel(channel) },
              on: {
                click: function (e) {
                  return _vm.change(e, channel._id)
                },
              },
            },
            [
              _vm.multiple
                ? _c("a-checkbox", {
                    staticClass: "segment-checkbox",
                    attrs: { checked: _vm.isSelectedChannel(channel) },
                    on: {
                      click: function (e) {
                        return _vm.change(e, channel._id)
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(channel.name))]),
            ],
            1
          )
        }),
        _vm._v(" "),
        _vm.getFilteredChannels("linkedin-unipile").length
          ? _c("div", { staticClass: "group-title" }, [
              _vm._v(_vm._s(_vm.$t("message.channelGroupLinkedin"))),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.getFilteredChannels("linkedin-unipile"), function (channel) {
          return _c(
            "div",
            {
              key: channel._id,
              staticClass: "list-item",
              class: { selected: _vm.isSelectedChannel(channel) },
              on: {
                click: function (e) {
                  return _vm.change(e, channel._id)
                },
              },
            },
            [
              _vm.multiple
                ? _c("a-checkbox", {
                    staticClass: "segment-checkbox",
                    attrs: { checked: _vm.isSelectedChannel(channel) },
                    on: {
                      click: function (e) {
                        return _vm.change(e, channel._id)
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(channel.name))]),
            ],
            1
          )
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }